import type RetentionPolicyTag from 'owa-service/lib/contract/RetentionPolicyTag';

/**
 * Comparator to sort retention policies by retention period in ascending order
 * @param tagA
 * @param tagB
 */
export default function compareTagsByRetentionPeriod(
    tagA: RetentionPolicyTag,
    tagB: RetentionPolicyTag
) {
    if (tagA.RetentionPeriod && tagB.RetentionPeriod) {
        return tagA.RetentionPeriod - tagB.RetentionPeriod;
    } else if (tagB.RetentionPeriod) {
        return 1;
    }
    return -1;
}
